import api from "../services/api";

// Service to create a new FAQ
export const createFAQ = async (question, answer, category) => {
  try {
    const payload = { question, answer, category };

    const response = await api.post("/faq-management/faqs/", payload);

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error creating FAQ:", error.message || error);
    return { success: false, error: error.message || "Failed to create FAQ" };
  }
};

// Service to fetch FAQs with optional archived filtering
export const fetchFAQs = async (archived = false) => {
  try {
    const response = await api.get("/faq-management/faqs/", {
      params: { archived },
    });

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching FAQs:", error.message || error);
    return { success: false, error: error.message || "Failed to fetch FAQs" };
  }
};

// Service to update an FAQ by its ID
export const updateFAQ = async (faqId, question, answer, category) => {
  try {
    const payload = { question, answer, category };

    const response = await api.put(`/faq-management/faqs/${faqId}`, payload);

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating FAQ:", error.message || error);
    return { success: false, error: error.message || "Failed to update FAQ" };
  }
};

// Service to archive an FAQ by its ID
export const archiveFAQ = async (faqId) => {
  try {
    const response = await api.delete(`/faq-management/faqs/${faqId}`);

    if (response.status === 200 && response.data.success) {
      return { success: true, message: "FAQ archived successfully" };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error archiving FAQ:", error.message || error);
    return { success: false, error: error.message || "Failed to archive FAQ" };
  }
};
